import React from "react";

export class ConnerCircleButton extends React.Component<{title:string}>{
    render(){
        return(
            <div className="cornerCirlceBtn">  
                {this.props.title}
            </div>
        )
    }
}